module.exports = __webpack_public_path__ + "static/media/mmume_02.5985209f.png";